<template>
  <q-page class="bg-accent text-white text-center flex flex-center">
    <div class="row q-col-gutter-y-xl justify-center">
      <div
        v-for="(umbrella, umbrellaIndex) in umbrellaList"
        :key="umbrellaIndex"
      >
        <q-card class="umbrella bg-white margin-x-80 q-pa-sm">
          <div class="row q-col-gutter-sm">
            <div
              v-for="(outcome, outcomeIndex) in umbrella.outcomes"
              :key="outcomeIndex"
            >
              <div v-if="getOutcomeImage(outcome)">
                <q-img
                  @click="selectOutcome(outcome)"
                  class="outcome-image"
                  v-ripple
                  :src="getOutcomeImage(outcome)"
                >
                </q-img>
              </div>
              <div v-else>
                <div
                  @click="selectOutcome(outcome)"
                  clickable
                  class="
                    outcome-mock-image
                    bg-accent
                    text-white text-center
                    flex flex-center
                  "
                >
                  <div>S</div>
                </div>
              </div>
            </div>
          </div>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
  import { getOutcomeImage } from "@/functions/getOutcomeImage";
  import { mapGetters } from "vuex";
  export default {
    computed: {
      ...mapGetters({
        umbrellaList: "outcomes/outcomesByUmbrella",
        nextRoute: "general/nextRoutePath",
      }),
    },
    mounted() {
      this.$store.dispatch("outcomes/loadAll").then((e) => {});
    },
    methods: {
      getOutcomeImage: getOutcomeImage,
      selectOutcome(outcome) {
        this.$store.commit("general/setSelectedOutcome", outcome);
        if (this.nextRoute) {
          let path = this.nextRoute;
          this.$router.push(path + "/" + outcome.id);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .umbrella {
    height: 137px;
    width: 140px;
    border-radius: 30px;
    transition: transform 0.2s;
  }

  .umbrella:hover {
    transform: scale(1.5);
  }

  .outcome-image {
    height: 34px;
    width: 34px;
  }

  .outcome-mock-image {
    height: 34px;
    width: 34px;
    border-radius: 100px;
  }

  .margin-x-80 {
    margin-left: 40px;
    margin-right: 40px;
  }

  .container {
    height: 100vh;
  }
</style>
